import React from 'react';
import { Button, FormControl, FormControlLabel, Grid, Paper, Radio, RadioGroup, Select, TextField, Typography, MenuItem } from "@mui/material";
import CheckIcon from '@material-ui/icons/Check';
import { styled } from "@mui/system";

const SelectWrapper = styled(Select)({
    '& .MuiSelect-icon': {
        display: 'none',
    },
    '& .MuiSelect-select.MuiSelect-select': {
        paddingTop: 5,
        paddingBottom: 5
    },
    color: 'white',
    fontSize: '14px',
    borderRadius: '50px',
    borderWidth: '1px',
    borderColor: '#ccc',
    borderStyle: 'solid',
    '&:focus': {
        borderColor: '#6c63ff',
    },
    display: 'inline-block',
    width: 'fit-content !important',
});

const FormControlWrapper = styled(FormControl)({
    display: "flex",
    marginLeft: "auto",
});

const GreenRadio = styled(Radio)({
    backgroundColor: 'white',
    '&:hover': {
        backgroundColor: 'white',
    },
    padding: '0',
    color: '#FFF',
    width: '18px', // novo tamanho do círculo
    height: '18px', // novo tamanho do círculo
    '&.Mui-checked': {
        color: '#4caf50'
    },
    '&.Mui-checked:hover': {
        backgroundColor: 'white',
    },
    '&.Mui-disabled': {
        color: '#AAA',
    },
    '&.Mui-disabled + .MuiFormControlLabel-label': {
        color: '#AAA',
    }
});


function PaymentInformation({ activeStep, plan, selectedPlan, handleChangePlan, paymentType, handlePaymentTypeChange }) {

    const { monthlyValue, yearlyValue, fullValue, discount } = plan.find((item) => item.config.name === selectedPlan).config;
   
    return (
        <Grid item xs={4}>
            {activeStep != 2 ?
                <Paper style={styles.containerPlan}>
                    <Grid style={{ display: 'grid', paddingRight: '18px', paddingTop: '20px' }}>
                        <FormControlWrapper variant="outlined">
                            <SelectWrapper
                                name="Plano"
                                labelId="plan-select-label"
                                id="plan-select"
                                value={selectedPlan}
                                onChange={handleChangePlan}
                                label="Plano"
                                SelectDisplayProps={{
                                    style: {
                                        paddingLeft: '0px',
                                    }
                                }}
                            >
                                <MenuItem value="corporate">Corporate</MenuItem>
                                <MenuItem value="enterprise">Enterprise</MenuItem>
                                <MenuItem value="premium">Premium</MenuItem>
                                <MenuItem value="light">Light</MenuItem>
                            </SelectWrapper>
                        </FormControlWrapper>
                    </Grid>
                    <Grid style={styles.containerGridPlan}>

                        <Typography style={styles.titlePlan}>
                            PUNTU
                        </Typography>

                        <Typography style={styles.titleNamePlan}>
                            PLANO ESCOLHIDO
                        </Typography>

                        <Typography style={styles.namePlan}>
                            {selectedPlan == "premium"?"Premium":''}
                            {selectedPlan == "enterprise"?"Enterprise":''}
                            {selectedPlan == "corporate"?"Corporate":''}
                            {selectedPlan == "light"?"Light":''}
                        </Typography>
                        {selectedPlan == 'light' ? '' :
                            <Typography style={styles.subTitlePlan}>
                                O mais completo.
                            </Typography>
                        }
                        {selectedPlan == 'light' ?
                            <Typography style={styles.descricao}>Resolva seus problemas de registro de ponto com nosso plano gratuito.</Typography> :
                            <Typography style={styles.descricao}>

                                Aumente a eficiência da sua gestão<br />
                                de ponto em larga escala com nossa<br />
                                solução personalizada para grandes<br />
                                empresas.
                            </Typography>
                        }
                        {
                            selectedPlan == 'light' ? '' :
                                <Grid container spacing={1} alignItems="center" style={styles.containerRadio}>
                                    <Grid item >
                                        <Typography style={styles.titleRadio}>
                                            Pagamento:
                                        </Typography>
                                    </Grid>
                                    <Grid item sx={{ paddingLeft: '0' }}>
                                        <RadioGroup aria-label="pagamento" name="pagamento" row value={paymentType} onChange={handlePaymentTypeChange}>
                                            <FormControlLabel
                                                value="mensal"
                                                control={<GreenRadio color="primary" sx={{ ml: 1, mr: 1 }} />}
                                                label="Mensal"
                                                labelPlacement="end"
                                                style={styles.radioControl}
                                            />
                                            <FormControlLabel
                                                value="anual"
                                                control={<GreenRadio color="primary" sx={{ ml: 1, mr: 1 }} />}
                                                label="Anual"
                                                labelPlacement="end"
                                                style={styles.radioControl}
                                            />
                                        </RadioGroup>
                                    </Grid>
                                </Grid>
                        }
                        {/* 
                        <Grid container spacing={1} alignItems="center" style={styles.containerCupom}>
                            <Grid item>
                                <Typography style={styles.titleCupom}>
                                    CUPOM:
                                </Typography>
                            </Grid>
                            <Grid item style={styles.gridInputCupom}>
                                <TextField
                                    InputProps={{
                                        style: {
                                            borderRadius: '50px',
                                            border: '1px solid white',
                                            height: '20px',
                                            alignSelf: 'flex-end',
                                            width: '8em'
                                        },
                                    }}
                                />
                                <Button
                                    color="primary"
                                    style={styles.buttonCupom}
                                    endIcon={<CheckIcon />}
                                >
                                    Aplicar
                                </Button>
                            </Grid>
                        </Grid> */}

                        <Grid style={styles.gridTest}>
                            {
                                selectedPlan == 'light' ? '' :
                                    <Typography style={styles.descriptionTest}>
                                        Teste grátis por 30 dias.<br />
                                        Depois, pague somente
                                    </Typography>
                            }
                            {
                                selectedPlan == 'light' ? '' :
                                    <Grid>
                                        <Typography style={styles.spansTestMensal}>
                                            <span style={{ fontSize: '1.8em' }}>{'R$'}</span>
                                            <span style={{ fontSize: '3.8em' }}>{paymentType === 'anual' ? yearlyValue : monthlyValue}</span>
                                            <span style={{ fontSize: '1.8em' }}>{'/mês'}</span>
                                        </Typography>
                                        {paymentType === 'anual' ?
                                            <Typography style={styles.spansTestAnual}>
                                                <span style={{ fontSize: '1em' }}>Desconto de {discount}.</span><br />
                                                <span style={{ fontSize: '1em' }}>Parcela única de {'R$'}{fullValue}</span>
                                            </Typography>
                                            : <></>
                                        }
                                    </Grid>
                            }
                        </Grid>
                    </Grid>
                </Paper>
                :
                <Paper style={styles.containerComplete}>
                    <Grid style={styles.containerGridComplete}>
                        <Typography style={styles.titleComplete}>
                            PUNTU
                        </Typography>
                        <Typography style={styles.where}>
                            Por onde<br />
                            você quer<br />
                            começar?
                        </Typography>
                        <Typography style={styles.firstInstructions}>
                            Acessar o painel para<br />
                            cadastras as escalas e<br />
                            funcionários para que<br />
                            eles possam bater o ponto.
                        </Typography>

                        <Button
                            style={styles.accesAccount}
                            href="https://app.puntu.digital"
                        >Acessar minha conta</Button>

                        <Typography style={styles.secondInstructions}>
                            Solicitar ajuda do<br />
                            nosso suporte para<br />
                            implementação guiada.
                        </Typography>
                        <Button
                            style={styles.helpMe}
                            href="https://api.whatsapp.com/send/?phone=5561996894936&text&type=phone_number&app_absent=0"
                        >Quero ajuda!!</Button>
                    </Grid>
                </Paper>
            }
        </Grid >
    )
}

export default PaymentInformation;

const styles = ({
    containerPlan: {
        height: '100%',
        width: '100%',
        backgroundColor: '#4950de',
        borderTopRightRadius: 30
    },
    containerGridPlan: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        // paddingTop: 25,
        paddingLeft: 45,
        paddingRight: 45,
        textAlign: 'left',
        paddingBottom: '0px'
    },
    titlePlan: {
        fontFamily: 'Montserrat',
        fontSize: 33,
        color: 'white',
        fontWeight: '800',
        paddingTop: '5px',
        marginBottom: '10px'
    },
    titleNamePlan: {
        fontFamily: 'Montserrat',
        fontWeight: '600',
        fontSize: 14,
        color: 'white',
        paddingTop: '10px'
    },
    namePlan: {
        fontFamily: 'Montserrat',
        fontSize: '37px',
        color: 'white',
        fontWeight: 'bold',
        marginTop: '-13px'
    },
    subTitlePlan: {
        fontFamily: 'Montserrat',
        fontSize: 15,
        color: 'white',
        fontWeight: 'bold',
        paddingTop: '15px'
    },
    descricao: {
        fontFamily: 'Montserrat',
        fontSize: 15,
        fontWeight: '600',
        color: 'white',
        lineHeight: '18px',
        paddingTop: '15px',
        paddingBottom: '35px',
        marginTop: '5px',
        borderBottom: '1px solid #00000021'
    },
    containerRadio: {
        paddingTop: '15px',
        paddingBottom: '15px',
        borderBottom: '1px solid #00000021'
    },
    titleRadio: {
        fontFamily: 'Montserrat',
        fontSize: 14,
        color: 'white',
        fontWeight: '800'
    },
    radioControl: {
        fontFamily: 'Montserrat',
        fontSize: 14,
        color: 'white',
        fontWeight: '800'
    },
    containerCupom: {
        paddingTop: '10px',
        paddingBottom: '5px',
        borderBottom: '1px solid #00000021'
    },
    titleCupom: {
        fontFamily: 'Montserrat',
        fontSize: 14,
        color: 'white',
        fontWeight: '800'
    },
    gridInputCupom: {
        display: 'flex',
        alignItems: 'center'
    },
    buttonCupom: {
        color: 'white',
        fontFamily: 'Montserrat',
        fontSize: 14,
        alignSelf: 'flex-end',
    },
    gridTest: {
        paddingTop: '20px',
        paddingBottom: '20px',
    },
    descriptionTest: {
        fontFamily: 'Montserrat',
        fontSize: 14,
        color: 'white',
        fontWeight: '600',
        paddingTop: '15px',
        lineHeight: '15px'
    },
    spansTestMensal: {
        fontFamily: 'Montserrat',
        fontSize: 16,
        color: 'white',
        fontWeight: '600',
        paddingBottom: '4px',
        whiteSpace: 'nowrap',
        margin: '0'
    },
    spansTestAnual: {
        fontFamily: 'Montserrat',
        fontSize: 18,
        color: 'white',
        paddingBottom: '4px',
        margin: '0'
    },
    containerComplete: {
        flexBasis: '30%',
        height: '100%',
        backgroundColor: '#4950de',
        borderTopRightRadius: 50,
        paddingBottom: '40px'
    },
    containerGridComplete: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: 45,
        textAlign: 'left'
    },
    titleComplete: {
        fontFamily: 'Montserrat',
        fontSize: 35,
        color: 'white',
        fontWeight: '800',
        paddingTop: '60px'
    },
    where: {
        fontFamily: 'Montserrat',
        fontSize: 45,
        color: 'white',
        fontWeight: '600',
        fontWeight: '600',
        lineHeight: '45px',
        paddingTop: '25px'
    },
    firstInstructions: {
        fontFamily: 'Montserrat',
        fontSize: 18,
        color: 'white',
        lineHeight: '18px',
        paddingTop: '45px'
    },
    accesAccount: {
        color: 'blue',
        backgroundColor: 'white',
        textTransform: 'none',
        fontFamily: 'Heebo',
        fontSize: 18,
        width: '12em',
        marginTop: '1em',
        borderRadius: '50em'
    },
    secondInstructions: {
        fontFamily: 'Montserrat',
        fontSize: 18,
        color: 'white',
        lineHeight: '18px',
        paddingTop: '45px'
    },
    helpMe: {
        color: 'blue',
        backgroundColor: 'white',
        textTransform: 'none',
        fontFamily: 'Heebo',
        fontSize: 18,
        width: '12em',
        marginTop: '1em',
        borderRadius: '50em'
    }
})

